import Router from "next/router";
import Script from "next/script";
import HomeHeader from "src/pages/seoComponent";
import { useSession } from "next-auth/react";
import KnowledgeBaseBackground from "@/admin/molecules/KnowledgeBaseBackground";
import LoadingState from "@/sharedComponents/atoms/LoadingState";
import { tawkLink } from "src/services/connection";

function AboutUs(): JSX.Element {
  const { status } = useSession();

  if (status === "authenticated") {
    Router.replace(
      {
        pathname: "/admin-portal/course-manager/all-courses",
      },
      "/admin-portal/course-manager/all-courses"
    );
  } else {
    return (
      <>
        <HomeHeader title="Knowlege Base" />
        <div className="w-full h-screen ">
          <Script strategy="lazyOnload" src={tawkLink} />
          <KnowledgeBaseBackground />
        </div>
      </>
    );
  }
  return (
    <div className="flex place-content-center h-screen">
      <LoadingState />
    </div>
  );
}

export default AboutUs;
